import { matchPath } from 'react-router'
import { useLocation } from 'react-router-dom'

const usePathUtils = () => {
  const { pathname } = useLocation()
  const isContactDetailsPage = matchPath(pathname, `/activity/contacts/:id`)
  const isAccountDetailsPage = matchPath(pathname, `/activity/accounts/:id`)
  const isAccountActivityPage = matchPath(pathname, `/activity`)
  return { isContactDetailsPage, isAccountDetailsPage, isAccountActivityPage }
}

export default usePathUtils
